import { render, staticRenderFns } from "./coffee-card-home.vue?vue&type=template&id=8ed32cde&scoped=true&"
import script from "./coffee-card-home.vue?vue&type=script&lang=js&"
export * from "./coffee-card-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-card-home.vue?vue&type=style&index=0&id=8ed32cde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed32cde",
  null
  
)

export default component.exports